import { api } from '@creditsights/api-ui-web';
import classNames from 'classnames/bind';
import React, { useEffect, useState } from 'react';
import fileDownload from 'js-file-download';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './Download.module.scss';
import { ROUTES } from '../../Base.constants';

const cx = classNames.bind(styles);

const Download = (): React.ReactElement => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [completed, setCompleted] = useState(false);
  const link = params.get('link');
  const articleId = params.get('articleId');
  let redirected = false;

  useEffect(() => {
    if (link) {
      (async () => {
        const response = await api.get(link, { responseType: 'blob', baseURL: '' });
        const contentDisposition = response.headers['content-disposition'];
        let fileName = link.split('/').reverse()[0];
        if (contentDisposition) {
          const filenamePar = 'filename="';
          const filenameParInd = contentDisposition.indexOf(filenamePar);
          if (filenameParInd > 0) {
            fileName = contentDisposition.substring(filenameParInd + filenamePar.length);
            if (fileName.charAt(fileName.length - 1) === '"') {
              fileName = fileName.substring(0, fileName.length - 1);
            }
          }
        }

        fileDownload(response.data, fileName);

        if (!redirected) {
          setCompleted(true);
        }
      })();

      if (articleId) {
        navigate(ROUTES.article(articleId));
        redirected = true;
      }
    } else {
      navigate('/');
    }
  }, [link]);

  let message = 'Redirecting...';

  if (!articleId) {
    message = !completed ? 'File is downloading' : 'File has been downloaded successfully';
  }

  return (
    <div className={cx('body')}>
      <div className={cx('text-box')}>
        <h1 className={cx('header')}>{message}</h1>
      </div>
    </div>
  );
};

export default Download;
